// src/data/countries.js
export const countryOptions = 
  [
    {'value': 'AF', 'label': 'Afghanistan', 'airport': true, 'seaport': false},
    {'value': 'AL', 'label': 'Albania', 'airport': true, 'seaport': true},
    {'value': 'DZ', 'label': 'Algeria', 'airport': true, 'seaport': true},
    {'value': 'AS', 'label': 'American Samoa', 'airport': true, 'seaport': true},
    {'value': 'AD', 'label': 'Andorra', 'airport': false, 'seaport': false},
    {'value': 'AO', 'label': 'Angola', 'airport': true, 'seaport': true},
    {'value': 'AI', 'label': 'Anguilla', 'airport': true, 'seaport': true},
    {'value': 'AQ', 'label': 'Antarctica', 'airport': true, 'seaport': false},
    {'value': 'AG', 'label': 'Antigua and Barbuda', 'airport': true, 'seaport': true},
    {'value': 'AR', 'label': 'Argentina', 'airport': true, 'seaport': true},
    {'value': 'AM', 'label': 'Armenia', 'airport': true, 'seaport': false},
    {'value': 'AW', 'label': 'Aruba', 'airport': true, 'seaport': true},
    {'value': 'AU', 'label': 'Australia', 'airport': true, 'seaport': true},
    {'value': 'AT', 'label': 'Austria', 'airport': true, 'seaport': false},
    {'value': 'AZ', 'label': 'Azerbaijan', 'airport': true, 'seaport': true},
    {'value': 'BS', 'label': 'Bahamas', 'airport': true, 'seaport': true},
    {'value': 'BH', 'label': 'Bahrain', 'airport': true, 'seaport': true},
    {'value': 'BD', 'label': 'Bangladesh', 'airport': true, 'seaport': true},
    {'value': 'BB', 'label': 'Barbados', 'airport': true, 'seaport': true},
    {'value': 'BY', 'label': 'Belarus', 'airport': true, 'seaport': false},
    {'value': 'BE', 'label': 'Belgium', 'airport': true, 'seaport': true},
    {'value': 'BZ', 'label': 'Belize', 'airport': true, 'seaport': true},
    {'value': 'BJ', 'label': 'Benin', 'airport': true, 'seaport': true},
    {'value': 'BM', 'label': 'Bermuda', 'airport': true, 'seaport': true},
    {'value': 'BT', 'label': 'Bhutan', 'airport': true, 'seaport': false},
    {'value': 'BO', 'label': 'Bolivia', 'airport': true, 'seaport': false},
    {'value': 'BA', 'label': 'Bosnia and Herzegovina', 'airport': true, 'seaport': false},
    {'value': 'BW', 'label': 'Botswana', 'airport': true, 'seaport': false},
    {'value': 'BR', 'label': 'Brazil', 'airport': true, 'seaport': true},
    {'value': 'BN', 'label': 'Brunei Darussalam', 'airport': true, 'seaport': true},
    {'value': 'BG', 'label': 'Bulgaria', 'airport': true, 'seaport': true},
    {'value': 'BF', 'label': 'Burkina Faso', 'airport': true, 'seaport': false},
    {'value': 'BI', 'label': 'Burundi', 'airport': true, 'seaport': false},
    {'value': 'CV', 'label': 'Cape Verde', 'airport': true, 'seaport': true},
    {'value': 'KH', 'label': 'Cambodia', 'airport': true, 'seaport': true},
    {'value': 'CM', 'label': 'Cameroon', 'airport': true, 'seaport': true},
    {'value': 'CA', 'label': 'Canada', 'airport': true, 'seaport': true},
    {'value': 'KY', 'label': 'Cayman Islands', 'airport': true, 'seaport': true},
    {'value': 'CF', 'label': 'Central African Republic', 'airport': true, 'seaport': false},
    {'value': 'TD', 'label': 'Chad', 'airport': true, 'seaport': false},
    {'value': 'CL', 'label': 'Chile', 'airport': true, 'seaport': true},
    {'value': 'CN', 'label': 'China', 'airport': true, 'seaport': true},
    {'value': 'CO', 'label': 'Colombia', 'airport': true, 'seaport': true},
    {'value': 'KM', 'label': 'Comoros', 'airport': true, 'seaport': true},
    {'value': 'CG', 'label': 'Congo', 'airport': true, 'seaport': true},
    {'value': 'CD', 'label': 'Democratic Republic of the Congo', 'airport': true, 'seaport': true},
    {'value': 'CK', 'label': 'Cook Islands', 'airport': true, 'seaport': true},
    {'value': 'CR', 'label': 'Costa Rica', 'airport': true, 'seaport': true},
    {'value': 'CI', 'label': "Côte d'Ivoire", 'airport': true, 'seaport': true},
    {'value': 'HR', 'label': 'Croatia', 'airport': true, 'seaport': true},
    {'value': 'CU', 'label': 'Cuba', 'airport': true, 'seaport': true},
    {'value': 'CY', 'label': 'Cyprus', 'airport': true, 'seaport': true},
    {'value': 'CZ', 'label': 'Czech Republic', 'airport': true, 'seaport': false},
    {'value': 'DK', 'label': 'Denmark', 'airport': true, 'seaport': true},
    {'value': 'DJ', 'label': 'Djibouti', 'airport': true, 'seaport': true},
    {'value': 'DM', 'label': 'Dominica', 'airport': true, 'seaport': true},
    {'value': 'DO', 'label': 'Dominican Republic', 'airport': true, 'seaport': true},
    {'value': 'EC', 'label': 'Ecuador', 'airport': true, 'seaport': true},
    {'value': 'EG', 'label': 'Egypt', 'airport': true, 'seaport': true},
    {'value': 'SV', 'label': 'El Salvador', 'airport': true, 'seaport': true},
    {'value': 'GQ', 'label': 'Equatorial Guinea', 'airport': true, 'seaport': true},
    {'value': 'ER', 'label': 'Eritrea', 'airport': true, 'seaport': true},
    {'value': 'EE', 'label': 'Estonia', 'airport': true, 'seaport': true},
    {'value': 'SZ', 'label': 'Swaziland', 'airport': true, 'seaport': false},
    {'value': 'ET', 'label': 'Ethiopia', 'airport': true, 'seaport': false},
    {'value': 'FJ', 'label': 'Fiji', 'airport': true, 'seaport': true},
    {'value': 'FI', 'label': 'Finland', 'airport': true, 'seaport': true},
    {'value': 'FR', 'label': 'France', 'airport': true, 'seaport': true},
    {'value': 'GA', 'label': 'Gabon', 'airport': true, 'seaport': true},
    {'value': 'GM', 'label': 'Gambia', 'airport': true, 'seaport': true},
    {'value': 'GE', 'label': 'Georgia', 'airport': true, 'seaport': true},
    {'value': 'DE', 'label': 'Germany', 'airport': true, 'seaport': true},
    {'value': 'GH', 'label': 'Ghana', 'airport': true, 'seaport': true},
    {'value': 'GR', 'label': 'Greece', 'airport': true, 'seaport': true},
    {'value': 'GL', 'label': 'Greenland', 'airport': true, 'seaport': true},
    {'value': 'GD', 'label': 'Grenada', 'airport': true, 'seaport': true},
    {'value': 'GU', 'label': 'Guam', 'airport': true, 'seaport': true},
    {'value': 'GT', 'label': 'Guatemala', 'airport': true, 'seaport': true},
    {'value': 'GN', 'label': 'Guinea', 'airport': true, 'seaport': true},
    {'value': 'GW', 'label': 'Guinea-Bissau', 'airport': true, 'seaport': true},
    {'value': 'GY', 'label': 'Guyana', 'airport': true, 'seaport': true},
    {'value': 'HT', 'label': 'Haiti', 'airport': true, 'seaport': true},
    {'value': 'HN', 'label': 'Honduras', 'airport': true, 'seaport': true},
    {'value': 'HK', 'label': 'Hong Kong', 'airport': true, 'seaport': true},
    {'value': 'HU', 'label': 'Hungary', 'airport': true, 'seaport': false},
    {'value': 'IS', 'label': 'Iceland', 'airport': true, 'seaport': true},
    {'value': 'IN', 'label': 'India', 'airport': true, 'seaport': true},
    {'value': 'ID', 'label': 'Indonesia', 'airport': true, 'seaport': true},
    {'value': 'IR', 'label': 'Iran', 'airport': true, 'seaport': true},
    {'value': 'IQ', 'label': 'Iraq', 'airport': true, 'seaport': true},
    {'value': 'IE', 'label': 'Ireland', 'airport': true, 'seaport': true},
    {'value': 'IL', 'label': 'Israel', 'airport': true, 'seaport': true},
    {'value': 'IT', 'label': 'Italy', 'airport': true, 'seaport': true},
    {'value': 'JM', 'label': 'Jamaica', 'airport': true, 'seaport': true},
    {'value': 'JP', 'label': 'Japan', 'airport': true, 'seaport': true},
    {'value': 'JO', 'label': 'Jordan', 'airport': true, 'seaport': true},
    {'value': 'KZ', 'label': 'Kazakhstan', 'airport': true, 'seaport': false},
    {'value': 'KE', 'label': 'Kenya', 'airport': true, 'seaport': true},
    {'value': 'KI', 'label': 'Kiribati', 'airport': true, 'seaport': true},
    {'value': 'KP', 'label': 'North Korea', 'airport': true, 'seaport': true},
    {'value': 'KR', 'label': 'South Korea', 'airport': true, 'seaport': true},
    {'value': 'KW', 'label': 'Kuwait', 'airport': true, 'seaport': true},
    {'value': 'KG', 'label': 'Kyrgyzstan', 'airport': true, 'seaport': false},
    {'value': 'LA', 'label': 'Laos', 'airport': true, 'seaport': false},
    {'value': 'LV', 'label': 'Latvia', 'airport': true, 'seaport': true},
    {'value': 'LB', 'label': 'Lebanon', 'airport': true, 'seaport': true},
    {'value': 'LS', 'label': 'Lesotho', 'airport': true, 'seaport': false},
    {'value': 'LR', 'label': 'Liberia', 'airport': true, 'seaport': true},
    {'value': 'LY', 'label': 'Libya', 'airport': true, 'seaport': true},
    {'value': 'LI', 'label': 'Liechtenstein', 'airport': false, 'seaport': false},
    {'value': 'LT', 'label': 'Lithuania', 'airport': true, 'seaport': true},
    {'value': 'LU', 'label': 'Luxembourg', 'airport': true, 'seaport': false},
    {'value': 'MG', 'label': 'Madagascar', 'airport': true, 'seaport': true},
    {'value': 'MW', 'label': 'Malawi', 'airport': true, 'seaport': false},
    {'value': 'MY', 'label': 'Malaysia', 'airport': true, 'seaport': true},
    {'value': 'MV', 'label': 'Maldives', 'airport': true, 'seaport': true},
    {'value': 'ML', 'label': 'Mali', 'airport': true, 'seaport': false},
    {'value': 'MT', 'label': 'Malta', 'airport': true, 'seaport': true},
    {'value': 'MH', 'label': 'Marshall Islands', 'airport': true, 'seaport': true},
    {'value': 'MR', 'label': 'Mauritania', 'airport': true, 'seaport': true},
    {'value': 'MU', 'label': 'Mauritius', 'airport': true, 'seaport': true},
    {'value': 'MX', 'label': 'Mexico', 'airport': true, 'seaport': true},
    {'value': 'FM', 'label': 'Micronesia', 'airport': true, 'seaport': true},
    {'value': 'MD', 'label': 'Moldova', 'airport': true, 'seaport': false},
    {'value': 'MC', 'label': 'Monaco', 'airport': false, 'seaport': true},
    {'value': 'MN', 'label': 'Mongolia', 'airport': true, 'seaport': false},
    {'value': 'ME', 'label': 'Montenegro', 'airport': true, 'seaport': true},
    {'value': 'MA', 'label': 'Morocco', 'airport': true, 'seaport': true},
    {'value': 'MZ', 'label': 'Mozambique', 'airport': true, 'seaport': true},
    {'value': 'MM', 'label': 'Myanmar', 'airport': true, 'seaport': true},
    {'value': 'NA', 'label': 'Namibia', 'airport': true, 'seaport': true},
    {'value': 'NR', 'label': 'Nauru', 'airport': true, 'seaport': true},
    {'value': 'NP', 'label': 'Nepal', 'airport': true, 'seaport': false},
    {'value': 'NL', 'label': 'Netherlands', 'airport': true, 'seaport': true},
    {'value': 'NZ', 'label': 'New Zealand', 'airport': true, 'seaport': true},
    {'value': 'NI', 'label': 'Nicaragua', 'airport': true, 'seaport': true},
    {'value': 'NE', 'label': 'Niger', 'airport': true, 'seaport': false},
    {'value': 'NG', 'label': 'Nigeria', 'airport': true, 'seaport': true},
    {'value': 'MK', 'label': 'North Macedonia', 'airport': true, 'seaport': false},
    {'value': 'NO', 'label': 'Norway', 'airport': true, 'seaport': true},
    {'value': 'OM', 'label': 'Oman', 'airport': true, 'seaport': true},
    {'value': 'PK', 'label': 'Pakistan', 'airport': true, 'seaport': true},
    {'value': 'PW', 'label': 'Palau', 'airport': true, 'seaport': true},
    {'value': 'PA', 'label': 'Panama', 'airport': true, 'seaport': true},
    {'value': 'PG', 'label': 'Papua New Guinea', 'airport': true, 'seaport': true},
    {'value': 'PY', 'label': 'Paraguay', 'airport': true, 'seaport': false},
    {'value': 'PE', 'label': 'Peru', 'airport': true, 'seaport': true},
    {'value': 'PH', 'label': 'Philippines', 'airport': true, 'seaport': true},
    {'value': 'PL', 'label': 'Poland', 'airport': true, 'seaport': true},
    {'value': 'PT', 'label': 'Portugal', 'airport': true, 'seaport': true},
    {'value': 'QA', 'label': 'Qatar', 'airport': true, 'seaport': true},
    {'value': 'RO', 'label': 'Romania', 'airport': true, 'seaport': true},
    {'value': 'RU', 'label': 'Russian Federation', 'airport': true, 'seaport': true},
    {'value': 'RW', 'label': 'Rwanda', 'airport': true, 'seaport': false},
    {'value': 'KN', 'label': 'Saint Kitts and Nevis', 'airport': true, 'seaport': true},
    {'value': 'LC', 'label': 'Saint Lucia', 'airport': true, 'seaport': true},
    {'value': 'VC', 'label': 'Saint Vincent and the Grenadines', 'airport': true, 'seaport': true},
    {'value': 'WS', 'label': 'Samoa', 'airport': true, 'seaport': true},
    {'value': 'SM', 'label': 'San Marino', 'airport': false, 'seaport': false},
    {'value': 'ST', 'label': 'São Tomé and Príncipe', 'airport': true, 'seaport': true},
    {'value': 'SA', 'label': 'Saudi Arabia', 'airport': true, 'seaport': true},
    {'value': 'SN', 'label': 'Senegal', 'airport': true, 'seaport': true},
    {'value': 'RS', 'label': 'Serbia', 'airport': true, 'seaport': false},
    {'value': 'SC', 'label': 'Seychelles', 'airport': true, 'seaport': true},
    {'value': 'SL', 'label': 'Sierra Leone', 'airport': true, 'seaport': true},
    {'value': 'SG', 'label': 'Singapore', 'airport': true, 'seaport': true},
    {'value': 'SK', 'label': 'Slovakia', 'airport': true, 'seaport': false},
    {'value': 'SI', 'label': 'Slovenia', 'airport': true, 'seaport': true},
    {'value': 'SB', 'label': 'Solomon Islands', 'airport': true, 'seaport': true},
    {'value': 'SO', 'label': 'Somalia', 'airport': true, 'seaport': true},
    {'value': 'ZA', 'label': 'South Africa', 'airport': true, 'seaport': true},
    {'value': 'SS', 'label': 'South Sudan', 'airport': true, 'seaport': false},
    {'value': 'ES', 'label': 'Spain', 'airport': true, 'seaport': true},
    {'value': 'LK', 'label': 'Sri Lanka', 'airport': true, 'seaport': true},
    {'value': 'SD', 'label': 'Sudan', 'airport': true, 'seaport': true},
    {'value': 'SR', 'label': 'Suriname', 'airport': true, 'seaport': true},
    {'value': 'SE', 'label': 'Sweden', 'airport': true, 'seaport': true},
    {'value': 'CH', 'label': 'Switzerland', 'airport': true, 'seaport': false},
    {'value': 'SY', 'label': 'Syria', 'airport': true, 'seaport': true},
    {'value': 'TW', 'label': 'Taiwan', 'airport': true, 'seaport': true},
    {'value': 'TJ', 'label': 'Tajikistan', 'airport': true, 'seaport': false},
    {'value': 'TZ', 'label': 'Tanzania', 'airport': true, 'seaport': true},
    {'value': 'TH', 'label': 'Thailand', 'airport': true, 'seaport': true},
    {'value': 'TL', 'label': 'Timor-Leste', 'airport': true, 'seaport': true},
    {'value': 'TG', 'label': 'Togo', 'airport': true, 'seaport': true},
    {'value': 'TO', 'label': 'Tonga', 'airport': true, 'seaport': true},
    {'value': 'TT', 'label': 'Trinidad and Tobago', 'airport': true, 'seaport': true},
    {'value': 'TN', 'label': 'Tunisia', 'airport': true, 'seaport': true},
    {'value': 'TR', 'label': 'Turkey', 'airport': true, 'seaport': true},
    {'value': 'TM', 'label': 'Turkmenistan', 'airport': true, 'seaport': false},
    {'value': 'TV', 'label': 'Tuvalu', 'airport': true, 'seaport': true},
    {'value': 'UG', 'label': 'Uganda', 'airport': true, 'seaport': false},
    {'value': 'UA', 'label': 'Ukraine', 'airport': true, 'seaport': true},
    {'value': 'AE', 'label': 'United Arab Emirates', 'airport': true, 'seaport': true},
    {'value': 'GB', 'label': 'United Kingdom', 'airport': true, 'seaport': true},
    {'value': 'US', 'label': 'United States', 'airport': true, 'seaport': true},
    {'value': 'UY', 'label': 'Uruguay', 'airport': true, 'seaport': true},
    {'value': 'UZ', 'label': 'Uzbekistan', 'airport': true, 'seaport': false},
    {'value': 'VU', 'label': 'Vanuatu', 'airport': true, 'seaport': true},
    {'value': 'VE', 'label': 'Venezuela', 'airport': true, 'seaport': true},
    {'value': 'VN', 'label': 'Vietnam', 'airport': true, 'seaport': true},
    {'value': 'YE', 'label': 'Yemen', 'airport': true, 'seaport': true},
    {'value': 'ZM', 'label': 'Zambia', 'airport': true, 'seaport': false},
    {'value': 'ZW', 'label': 'Zimbabwe', 'airport': true, 'seaport': false}
  ];
  